import { render } from "./DirectorNavbar.vue?vue&type=template&id=707ac894&scoped=true"
import script from "./DirectorNavbar.vue?vue&type=script&lang=js"
export * from "./DirectorNavbar.vue?vue&type=script&lang=js"

import "./DirectorNavbar.vue?vue&type=style&index=0&id=707ac894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707ac894"]])

export default __exports__